import React from 'react';

export const renderText = (item) => {
if (!item) return null;
if (typeof item === 'string') return item;

if (item.compatibility || item.explanation || item.reason) {
return (
<span>
{item.compatibility && <strong>Compatibilité : {item.compatibility} <br /></strong>}
{item.explanation || item.reason}
</span>
);
}

if (item.skill) {
return (
<span>
<strong>{item.skill} :</strong> {item.justification || item.details}
</span>
);
}

if (item.gap) {
return (
<span>
<strong>{item.gap} :</strong> {item.details || item.justification}
</span>
);
}

if (item.training || item.title) {
return (
<span>
<strong>{item.training || item.title} :</strong> {item.details || item.justification || item.description}
</span>
);
}

return (
<span>
{Object.entries(item).map(([k, v]) => (
<span key={k}><strong>{k} :</strong> {v} <br /></span>
))}
</span>
);
};

export const textOf = (item) => {
if (!item) return '';
if (typeof item === 'string') return item;
if (item.compatibility || item.explanation || item.reason)
return `${item.compatibility ? `<strong>Compatibilité : ${item.compatibility}</strong><br>` : ''}${item.explanation || item.reason || ''}`;
if (item.skill)
return `<strong>${item.skill} :</strong> ${item.justification || item.details || ''}`;
if (item.gap)
return `<strong>${item.gap} :</strong> ${item.details || item.justification || ''}`;
if (item.training || item.title)
return `<strong>${item.training || item.title} :</strong> ${item.details || item.justification || item.description || ''}`;
return Object.entries(item).map(([k, v]) => `<strong>${k} :</strong> ${v}`).join(' | ');
};

export const buildPdfHtml = (a) => {
const summaryText = typeof a.summary === 'string' ? a.summary : JSON.stringify(a.summary);

const strongList = (a.strong_points || []).map((p) =>
`<li style="margin-bottom:8px;line-height:1.65;color:#15803d;font-size:12.5px;overflow-wrap:break-word;word-break:break-word;">${textOf(p)}</li>`
).join('');

const gapList = (a.gaps || []).map((g) =>
`<li style="margin-bottom:8px;line-height:1.65;color:#b91c1c;font-size:12.5px;overflow-wrap:break-word;word-break:break-word;">${textOf(g)}</li>`
).join('');

const trainings = (a.recommended_trainings || []).map((item, i) =>
`<div style="width:calc(50% - 6px);background:rgba(255,255,255,.65);border-radius:10px;padding:9px 11px;font-size:12.5px;color:#78350f;line-height:1.6;box-sizing:border-box;margin-bottom:8px;overflow-wrap:break-word;word-break:break-word;"><strong style="color:#b45309;">${i + 1}.</strong> ${textOf(item)}</div>`
).join('');

return `<div style="font-family:'Segoe UI',Arial,sans-serif;font-size:13px;color:#1e293b;padding:8px;width:774px;box-sizing:border-box;">
<div style="background:linear-gradient(120deg,#0f2942,#117aa7);border-radius:14px;padding:18px 22px;margin-bottom:16px;color:white;">
<div style="font-size:18px;font-weight:800;margin-bottom:3px;">Analyse de Compatibilité</div>
<div style="font-size:11.5px;opacity:.8;">Comparaison détaillée entre le profil du candidat et l'offre d'emploi</div>
</div>
<div style="background:#fff;border:1.5px solid rgba(17,122,167,.18);border-radius:14px;padding:16px 18px;margin-bottom:14px;box-sizing:border-box;">
<div style="display:flex;align-items:center;gap:8px;margin-bottom:10px;">
<div style="width:4px;height:20px;background:#117aa7;border-radius:4px;flex-shrink:0;"></div>
<span style="font-size:13.5px;font-weight:700;color:#0d5a7a;">Synthèse de Compatibilité</span>
</div>
<p style="margin:0;line-height:1.65;color:#475569;font-size:13px;overflow-wrap:break-word;word-break:break-word;">${summaryText}</p>
</div>
<div style="display:flex;gap:12px;margin-bottom:14px;">
<div style="flex:1;min-width:0;background:linear-gradient(135deg,#f0fdf4,#dcfce7);border:1.5px solid rgba(34,197,94,.25);border-radius:14px;padding:14px 16px;box-sizing:border-box;overflow-wrap:break-word;word-break:break-word;">
<div style="display:flex;align-items:center;gap:8px;margin-bottom:10px;">
<div style="width:4px;height:19px;background:#22c55e;border-radius:4px;flex-shrink:0;"></div>
<span style="font-size:12.5px;font-weight:700;color:#166534;">✅ Points Forts</span>
</div>
<ul style="margin:0;padding-left:16px;overflow-wrap:break-word;word-break:break-word;">${strongList}</ul>
</div>
<div style="flex:1;min-width:0;background:linear-gradient(135deg,#fff1f2,#ffe4e6);border:1.5px solid rgba(239,68,68,.22);border-radius:14px;padding:14px 16px;box-sizing:border-box;overflow-wrap:break-word;word-break:break-word;">
<div style="display:flex;align-items:center;gap:8px;margin-bottom:10px;">
<div style="width:4px;height:19px;background:#ef4444;border-radius:4px;flex-shrink:0;"></div>
<span style="font-size:12.5px;font-weight:700;color:#991b1b;">⚠️ Lacunes Identifiées</span>
</div>
<ul style="margin:0;padding-left:16px;overflow-wrap:break-word;word-break:break-word;">${gapList}</ul>
</div>
</div>
<div style="background:linear-gradient(135deg,#fffbeb,#fef3c7);border:1.5px solid rgba(245,158,11,.28);border-radius:14px;padding:14px 18px;box-sizing:border-box;">
<div style="display:flex;align-items:center;gap:8px;margin-bottom:12px;">
<div style="width:4px;height:19px;background:#f59e0b;border-radius:4px;flex-shrink:0;"></div>
<span style="font-size:12.5px;font-weight:700;color:#92400e;">💡 Formations et Actions Recommandées</span>
</div>
<div style="display:flex;flex-wrap:wrap;gap:8px;">${trainings}</div>
</div>
</div>`;
};
